<template>
    <select @change="switchLocale($event)" v-model="$i18n.locale" class="locale__container" v-if="isFrancoCountry">
        <option v-for="(locale, i) in locales" :key="`locale-${i}`" :value="locale.value">
            {{ locale.name }}
        </option>
    </select>
</template>

<script>
import { ref, computed } from "vue";
import { injectStore } from "redux-vuex";
import { getValueFromPath } from "@/support/helpers";

export default {
    name: "LocaleSwitcher",
    emits: [ "toggle-locale" ],

    setup(_, { emit }) {
        const locales = ref([
            {
                name: "English",
                value: "en",
            }, 
            {
                name: "French",
                value: "fr",
            },
        ]);
        const store = injectStore();
        const checkoutData = ref(store.getState());
        const currency = ref(
            getValueFromPath(
                checkoutData.value,
                "currency.current",
            ) || null,
        );

        const isFrancoCountry = computed(() => {
            switch (currency.value) {
            case "XAF":
            case "XOF":
            case "CFA":
            case "USD":
            case "EUR":
            case "GBP":
                return true;
            default:
                return false;
            }
        });

        const switchLocale = ({ target }) => {
            // Pass this value to state to ensure the value is maintained across the application
            emit("toggle-locale", target.value);
        };
        

        return {
            locales,
            switchLocale,
            isFrancoCountry,
        };
    },
};
</script>

<style lang="scss" scoped>
.locale__container {
    border: none;
    outline: none;
    color: $black-3;
    margin-left: auto;
    cursor: pointer;
    margin-right: 5px;
}
</style>